module.exports = __webpack_public_path__ + "img/bg-video-2.652ed027.png";